export interface IAttachmentIcon {
  className: string;
  modifier: string;
}

export const attachmentIcon = (mime?: string, name?: string): IAttachmentIcon => {
  const type = mime ?? '';
  const extension = (name ?? '').split('.').pop()?.toLowerCase() ?? '';

  if (type.startsWith('image/')) {
    return { className: 'far fa-image', modifier: 'image' };
  }
  if (type === 'application/pdf' || extension === 'pdf') {
    return { className: 'far fa-file-pdf', modifier: 'pdf' };
  }
  if (['xlsx', 'xls', 'ods'].includes(extension)) {
    return { className: 'far fa-file-excel', modifier: 'sheet' };
  }
  if (extension === 'csv') {
    return { className: 'fas fa-table', modifier: 'table' };
  }
  if (['doc', 'docx', 'odt'].includes(extension) || type.startsWith('text/')) {
    return { className: 'far fa-file-alt', modifier: 'text' };
  }
  return { className: 'far fa-file', modifier: 'generic' };
};

export const attachmentTab = (mime?: string, name?: string): 'doc' | 'img' =>
  attachmentIcon(mime, name).modifier === 'image' ? 'img' : 'doc';
